module.exports = __webpack_public_path__ + "static/img/packaged-fuel_64.6492e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-fuel_64.png
// module id = eRim
// module chunks = 0